import {
  encodeURIPercentChar,
  makeDownloadUrl,
} from '@wandb/weave/common/util/url';

export function formatDownloadUrl(
  url: string | null | undefined,
  filename?: string
): string {
  if (!url) {
    // when this is called we can be pretty sure the URL is set, but in the case
    // that it's not, we should return something safe that won't cause an error
    return '';
  }
  return makeDownloadUrl(encodeURIPercentChar(url), filename);
}
